import BeforeAfterSlider from "../sliders/BeforeAfterSlider";

export default function ResultsSection() {

  return (

    <section className="py-24 bg-[#f8f5f1]">

      <div className="max-w-7xl mx-auto px-6">

        {/* TITLE */}

        <div className="text-center mb-16">

          <h2 className="font-serif text-4xl md:text-5xl text-alkimya-navy mb-6">
            Risultati Reali
          </h2>

          <p className="text-gray-600 max-w-xl mx-auto">
            Ogni trattamento nasce da protocolli personalizzati e tecnologie
            avanzate per risultati visibili e duraturi.
          </p>

        </div>

        {/* GRID */}

        <div className="grid md:grid-cols-2 gap-16">

          {/* ACNE */}

          <div>

            <h3 className="text-xl font-serif mb-6 text-center">
              Trattamento Acne
            </h3>

            <BeforeAfterSlider
              before="/images/results/acne-before.jpg"
              after="/images/results/acne-after.jpg"
            />

          </div>

          {/* MACCHIE */}

          <div>

            <h3 className="text-xl font-serif mb-6 text-center">
              Riduzione Macchie
            </h3>

            <BeforeAfterSlider
              before="/images/results/macchie-before.jpg"
              after="/images/results/macchie-after.jpg"
            />

          </div>

          {/* ANTIAGE */}

          <div>

            <h3 className="text-xl font-serif mb-6 text-center">
              Trattamento Antiage
            </h3>

            <BeforeAfterSlider
              before="/images/results/antiage-before.jpg"
              after="/images/results/antiage-after.jpg"
            />

          </div>

          {/* PORI */}

          <div>

            <h3 className="text-xl font-serif mb-6 text-center">
              Riduzione Pori
            </h3>

            <BeforeAfterSlider
              before="/images/results/pori-before.jpg"
              after="/images/results/pori-after.jpg"
            />

          </div>

        </div>

      </div>

    </section>

  );

}